@if (!isHidden()) {
    @let tooltipPosition = 'right';
    <div 
        class="container-menu-options" 
        animate.enter="slide-in-from-left"
        animate.leave="slide-out-to-left">

        <section-item 
            [icon]="'magicpen'" 
            [text]="('document.edit.sessionOptions.correctTexts' | translate)" 
            [tooltipPosition]="tooltipPosition" 
            (click)="typoAllTextsIa.emit(); close.emit();"
        />

        <section-item
            [icon]="'edit-2'"
            [text]="('document.edit.sessionOptions.renameSession' | translate)"
            [tooltipPosition]="tooltipPosition"
            (click)="changeNameSession.emit(); close.emit();"
        />

        @if (isChecklistMode()) {
            <section-item
                [icon]="'text'"
                [text]="((hasDescription() ? 'document.edit.sessionOptions.editDescription' : 'document.edit.sessionOptions.addDescription') | translate)"
                [tooltipPosition]="tooltipPosition"
                (click)="editDescription.emit(); close.emit();"
            />
        }

        <section-item
            [icon]="'trash'" 
            [text]="('document.edit.sessionOptions.deleteSession' | translate)" 
            [type]="'danger'" 
            [tooltipPosition]="tooltipPosition" 
            (click)="editSessionService.removeSession(section()._id); close.emit();"
        />
    </div>
}
